<template>
  <v-app :dark="darkMode">
      <v-navigation-drawer :mini-variant.sync="mini" v-model="drawer" class="elevation-0" fixed clipped app style="margin-top:64px;background-color:#E53935">
       
          <v-treeview
          style="margin-top:125px;font-size:10px"
               :items="items"
            ></v-treeview>
          <v-divider style="margin-top:25px"></v-divider>
    </v-navigation-drawer>
    <v-content class="cntnt" style="padding-left: 0px !important">
      <transition :name="transitionName" mode="out-in" @beforeLeave="beforeLeave" @enter="enter">
        <router-view></router-view>
      </transition>
    </v-content>
  </v-app>
</template>


<script>
import Avatar from "vue-avatar";
import config from "./../../config.json";
const DEFAULT_TRANSITION = "fade";

export default {
  components: {
    Avatar
  },
  data() {
    return {
      prevHeight: 0,
      transitionName: DEFAULT_TRANSITION,
      drawer: null,
      fav: true,
      menu: false,
      darkMode: false,
      logOutDialog: false,
      loggedInUserName: null,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,
      menus: [],
      all: true,

      searchBtn: false,

      selectedLevel: sessionStorage.level,
    levels: ["Undergraduate", "Postgraduate", "PhD", "Short Term Programs"],

    selectedCountry: sessionStorage.country,
    countries: null,

    selectedCategory: null,
    categories: ["Direct", "Indirect", "Both"],

    inputRules: [v => !!v || "Please select a course"],

    form: {
      courseName: sessionStorage.course
    },

    searchData: [],
    university: [],
    level: [],
    country: [],

    xyz: null,

      notification: {
      count: null,
      show: null
    },

    items: [],

    deleteClicked: false
    };
    
  },

  mounted() {
    this.axios
        .get(config.API + "CategoryTree", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.items = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
  },

  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
  },
};
</script>

<style lang="css">
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.hedr {
  background-color: #c5e1a5 !important;
}
.v-treeview-node__label {
    font-size: 12px !important;
    margin-left: 6px !important;
    flex-grow: 1 !important;
    flex-shrink: 0 !important;
}
.cntnt {
  padding-top: 0px !important;
}
.divps {
  margin-bottom: -15px !important;
}
.reds {
  color: red !important;
}
.basil--text {
  color: #356859 !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
.st {
    width: 400px !important;
}
</style>